import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
export var history = createBrowserHistory();
export var routerSelector = function (state) { return state.router; };
export var reducer = function (history) { return connectRouter(history); };
